import React from 'react';

import { PLAN_OPTIONS_GROUPS, PLAN_OPTIONS_NAMES } from '../../constants/config';
import { InfoTooltip } from '../InfoTooltip/InfoTooltip';
import {
  StyledCell,
  StyledCheckIcon,
  StyledCrossIcon,
  StyledOptionContainer,
  StyledOptionGroup,
  StyledOptionGroupHeader,
  StyledOptionHeader,
  StyledPlansOptionsTable,
} from './PlansOptionsTableStyles';

export const PlansOptionsTable = React.memo(({ products }) => {
  const productsWithOptions = products.filter(({ options }) => Boolean(options));

  return (
    <StyledPlansOptionsTable>
      <StyledOptionGroup sticky withSeparator={false}>
        <StyledOptionHeader>
          <StyledCell>Features Breakdown</StyledCell>
          {productsWithOptions.map(({ name }) => (
            <StyledCell key={name}>{name}</StyledCell>
          ))}
        </StyledOptionHeader>
      </StyledOptionGroup>
      {PLAN_OPTIONS_GROUPS.map(({ name, options }) => {
        return (
          <StyledOptionGroup key={name}>
            <StyledOptionGroupHeader>{name}</StyledOptionGroupHeader>
            {options.map((key) => {
              const optionName = PLAN_OPTIONS_NAMES[key];
              const optionDescription = optionName.description;

              return (
                <StyledOptionContainer key={key} disabled={optionName.comingSoon}>
                  <StyledCell description={optionDescription} disabled={optionName.comingSoon}>
                    <span>
                      {optionName.name}
                      {optionName.comingSoon && <sup>(coming soon)</sup>}
                      {optionDescription && <InfoTooltip>{optionDescription}</InfoTooltip>}
                    </span>
                  </StyledCell>
                  {productsWithOptions.map(({ options, name }) => {
                    let value = <StyledCrossIcon />;
                    let description = null;

                    if (options[key]) {
                      const {
                        text = null,
                        disabled = false,
                        description: planDescription = null,
                      } = options[key];

                      description = planDescription;
                      if (!disabled) {
                        value = text || <StyledCheckIcon />;
                      }
                    }

                    return (
                      <StyledCell key={name}>
                        {value}
                        {description && <InfoTooltip>{description}</InfoTooltip>}
                      </StyledCell>
                    );
                  })}
                </StyledOptionContainer>
              );
            })}
          </StyledOptionGroup>
        );
      })}
    </StyledPlansOptionsTable>
  );
});
